import _ from 'lodash';
import {
  extendsModule, baseForm, registerMfModule, moduleKeys,
} from 'src/store/base';
import * as types from 'src/store/types';

import { setIdentityData } from 'src/store/modules/creative/normal-creative/helpers';
import { isCreativeHasIdentityWhite } from 'src/const/whiteList';
import formGroupMain from './form-group-main';

export default extendsModule(baseForm, {
  state: {
    _moduleKey: 'procedural-creative-form',
    _formGroups: moduleKeys([formGroupMain]),

    activeType: '', // 默认video
    identityAuthorizationState: 0,
  },
  getters: {
    pcdAdStorageKey(state, getters, rootState, rootGetter) {
      return `${rootGetter['campaign/modelKey']}:procedural-ad`;
    },

  },
  mutations: {
    [types.UPDATE_ACTIVE_TYPE](state, type) {
      state.activeType = type;
    },
    [types.SET_PCD_IDENTITY_AUTHORIZATION_STATE](state, status) {
      state.identityAuthorizationState = status;
    },
  },
  actions: {
    setPcdAd({ dispatch }, formData = {}) {
      dispatch('fillForm', formData);
    },
    savePcdAdDraft({ getters }, ad) {
      try {
        window.localStorage.setItem(getters.pcdAdStorageKey, JSON.stringify(ad));
      } catch (e) {
        // 修复因为localStorage内存溢出导致的报错：The quota has been exceeded。
      }
    },
    loadPcdAdDraft({ getters }) {
      const ad = localStorage.getItem(getters.pcdAdStorageKey);
      return ad ? JSON.parse(ad) : null;
    },
    removePcdAdDraft({ getters }) {
      localStorage.removeItem(getters.pcdAdStorageKey);
    },
    removePcdAdData({ dispatch }) {
      dispatch('removePcdAdDraft'); // 清理本地缓存
      dispatch('creative/playable-card-form/resetPlayable', null, { root: true }); // 重置试玩信息
      dispatch('setPcdAd'); // 重置创意素材
    },
    // 利用后端创意详情接口数据设置vuex
    async setPcdAdByCreativeDetail({ commit, dispatch }, creativeDetail = {}) {
      const clone = _.cloneDeep(creativeDetail);
      clone.call_to_action_list = clone.advanced_creative;
      clone.resetAutoName = true; // 表示需要重新设置创意名称自动生成checkbox
      if (isCreativeHasIdentityWhite()) {
        // 编辑和复制时 对历史数据identity字段处理
        const res = await setIdentityData(clone);
        const { adDetail = {}, availableStatus } = res;
        if (_.has(adDetail, 'identity_id')) {
          clone.identity_data = adDetail.identity_data;
          clone.identity_id = adDetail.identity_id;
          clone.identity_type = adDetail.identity_type;
        }
        if (typeof availableStatus === 'number') {
          commit(types.SET_PCD_IDENTITY_AUTHORIZATION_STATE, availableStatus);
        }
      }

      dispatch('fillForm', clone); // 设置素材信息
      dispatch('creative/playable-card-form/openAndSetPlayableUrl', creativeDetail.playable_url, { root: true }); // 设置试玩信息
    },
  },
  modules: registerMfModule([formGroupMain]),
});
